import script from "./RoboticArmIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./RoboticArmIcon.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__